import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: ['datasDonutsChart'],
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient2 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient3 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient4 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient5 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);

    this.gradient.addColorStop(0, 'rgba(4, 58, 70, 0.9)');
    this.gradient.addColorStop(0.5, 'rgba(4, 58, 70, 0.25)');
    this.gradient.addColorStop(1, 'rgba(4, 58, 70, 0)');

    this.gradient2.addColorStop(0, 'rgba(153, 55, 26, 0.9)');
    this.gradient2.addColorStop(0.5, 'rgba(153, 55, 26, 0.25)');
    this.gradient2.addColorStop(1, 'rgba(153, 55, 26, 0)');

    this.gradient3.addColorStop(0, 'rgba(255, 196, 30, 0.5)');
    this.gradient3.addColorStop(0.5, 'rgba(255, 196, 30, 0.25)');
    this.gradient3.addColorStop(1, 'rgba(255, 196, 30, 0)');

    this.gradient4.addColorStop(0, 'rgba(31, 85, 97, 0.9)');
    this.gradient4.addColorStop(0.5, 'rgba(31, 85, 97, 0.25)');
    this.gradient4.addColorStop(1, 'rgba(31, 85, 97, 0)');

    this.gradient5.addColorStop(0, 'rgba(210, 163, 73, 0.9)');
    this.gradient5.addColorStop(0.5, 'rgba(210, 163, 73, 0.25)');
    this.gradient5.addColorStop(1, 'rgba(210, 163, 73, 0)');

    this.renderChart(
      {
        labels: this.getLabels(this.datasDonutsChart),
        datasets: [
          {
            data: this.getViews(this.datasDonutsChart),
            backgroundColor: [
              this.gradient,
              this.gradient2,
              this.gradient3,
              this.gradient4,
              this.gradient5,
            ],
          },
        ],
      },
      {},
    );
  },
  methods: {
    getLabels(periode) {
      const labels = [];
      // console.log(periode)
      for (let i = 0; i < periode.length; i++) {
        labels.push(periode[i].url);
      }
      return labels;
    },
    getViews(periode) {
      const datas = [];
      for (let i = 0; i < periode.length; i++) {
        datas.push(periode[i].pageViews);
      }
      return datas;
    },
  },
};
